/* Footiva — wysyłka ekspresowa (+5,99 zł).
   Ładowany RAZ w layout/theme.liquid (defer, po pubsub.js). Dzięki temu przeżywa
   odświeżenie szuflady koszyka, które podmienia HTML bez przeładowania strony.
   Termin wysyłki i zwrot 5,99 zł obsługuje panel footiva.j.pl po SKU EKSPRES. */
(function () {
  var VARIANT = 57726004396358;

  var HOLIDAYS = ["2026-11-11","2026-12-24","2026-12-25","2027-01-01","2027-01-06","2027-03-29","2027-05-03","2027-05-27",
                  "2027-11-01","2027-11-11","2027-12-24","2028-01-06","2028-04-17","2028-05-01","2028-05-03","2028-06-15",
                  "2028-08-15","2028-11-01","2028-12-25","2028-12-26"];

  /* Adresy koszyka bierzemy z window.routes (tak jak footiva-upsell-modal.liquid),
     żeby nie wysypać się na prefiksie językowym w URL-u. */
  function route(key, fallback) {
    return ((window.routes && window.routes[key]) || fallback) + '.js';
  }

  /* Czas liczony dla Europe/Warsaw przez Intl, nie z zegara urządzenia. */
  function warsaw() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', weekday: 'short', hour12: false
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      ymd: p.year + '-' + p.month + '-' + p.day,
      hm: (p.hour === '24' ? '00' : p.hour) + ':' + p.minute,
      wd: p.weekday
    };
  }

  function available() {
    var w = warsaw();
    return w.wd !== 'Sat' && w.wd !== 'Sun' && HOLIDAYS.indexOf(w.ymd) === -1 && w.hm < '12:00';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function sectionsParam(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
    return null;
  }

  /* W szufladzie odświeżamy ją mechanizmem motywu (Section Rendering API),
     na stronie koszyka zostaje przeładowanie. */
  function change(box, url, body) {
    var inDrawer = !!box.closest('cart-drawer');
    var drawer = document.querySelector('cart-drawer');
    if (inDrawer) {
      var ids = sectionsParam(drawer);
      if (ids) {
        body.sections = ids;
        body.sections_url = window.location.pathname;
      }
    }
    return post(url, body).then(function (data) {
      if (inDrawer && drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        drawer.renderContents(data);
        setTimeout(scan, 0);
      } else {
        window.location.reload();
      }
      return data;
    });
  }

  /* Ekspres w koszyku to zawsze 1 szt. — oznaczamy jego komórkę,
     resztę (ukrycie selektora ilości) robi assets/footiva-ekspres.css. */
  function markLines() {
    var inputs = document.querySelectorAll('input[data-quantity-variant-id="' + VARIANT + '"]');
    Array.prototype.forEach.call(inputs, function (input) {
      var cell = input.closest('.cart-item__quantity') || input.closest('td');
      if (cell && !cell.hasAttribute('data-ftv-ekspres-line')) {
        cell.setAttribute('data-ftv-ekspres-line', '');
      }
    });
  }

  function init(box) {
    box.setAttribute('data-ready', '1');

    var id = Number(box.getAttribute('data-variant'));
    var inCart = Number(box.getAttribute('data-in-cart'));
    var others = Number(box.getAttribute('data-others'));
    var cb = box.querySelector('.footiva-ekspres__box');
    if (!cb) return;

    /* Sam ekspres w koszyku (bez butów) → usuwamy. Ilość większa niż 1 → ustawiamy 1. */
    if (inCart > 0 && (others === 0 || inCart > 1)) {
      change(box, route('cart_change_url', '/cart/change'), { id: String(id), quantity: others === 0 ? 0 : 1 })
        .catch(function () {});
      return;
    }

    /* Widoczny tylko gdy są inne produkty ORAZ jest dzień roboczy przed 12:00,
       albo ekspres już siedzi w koszyku (żeby dało się go odznaczyć). */
    if (others === 0 || (!available() && inCart === 0)) return;

    box.hidden = false;

    cb.addEventListener('change', function () {
      box.classList.add('is-busy');
      var url = cb.checked ? route('cart_add_url', '/cart/add') : route('cart_change_url', '/cart/change');
      var body = cb.checked ? { items: [{ id: id, quantity: 1 }] } : { id: String(id), quantity: 0 };
      change(box, url, body).catch(function () {
        box.classList.remove('is-busy');
        cb.checked = !cb.checked;
        alert('Nie udało się zmienić wysyłki — spróbuj ponownie.');
      });
    });
  }

  var queued = false;

  function scan() {
    queued = false;
    markLines();
    var boxes = document.querySelectorAll('.footiva-ekspres:not([data-ready])');
    Array.prototype.forEach.call(boxes, init);
  }

  function scanSoon() {
    if (queued) return;
    queued = true;
    setTimeout(scan, 0);
  }

  function start() {
    scan();

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, scanSoon);
    }

    if (window.MutationObserver) {
      ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
        var node = document.querySelector(sel);
        if (node) new MutationObserver(scanSoon).observe(node, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();